import { Component, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-landing-background',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './landing-background.html',
  styleUrls: ['./landing-background.scss']
})
export class LandingBackground {
  isLoginPage = signal(false);

  routerSub: Subscription;
  constructor(private router: Router) { 
    this.routerSub = this.router.events.subscribe(() => {
      this.isLoginPage.set(this.router.url.startsWith('/auth'));
    });
  }
}